import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LeafletMarkerClusterModule } from '@asymmetrik/ngx-leaflet-markercluster';
import { ExportDialogModule } from '@core/components/export-dialog/export-dialog.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { CustomCompileService } from '@core/services/custom-compile.service';
import { FuseSidebarModule } from '@fuse/components';
import { FormatAddressPipe } from '@fuse/pipes/format-address/format-address.pipe';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DialogLocationEnvironmentModule } from './dialogs/dialog-location-environment/dialog-location-environment.module';
import { DialogLocationSectorModule } from './dialogs/dialog-location-sector/dialog-location-sector.module';
import { DialogLocationsModule } from './dialogs/dialog-location/dialog-locations.module';
import { DialogLocationService } from './dialogs/dialog-location/dialog-locations.service';
import { FilterLocationsModule } from './filter/filter-locations.module';
import { LocationComponent } from './locations.component';
import { LocationService } from './services/location.service';
import { DatatableLocationsComponent } from './views/datatable/datatable-locations.component';
import { MapLocationsComponent } from './views/map/map-locations.component';
import { PopupMarkerComponent } from './views/map/popup-marker.component';

const routes: Routes = [
  {
    path: 'localizacoes',
    component: LocationComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'CORE.SERVICES.NAVIGATION.LOCATIONS.TITLE' }
  }
];

@NgModule({
  entryComponents: [
    PopupMarkerComponent
  ],
  declarations: [
    LocationComponent,
    DatatableLocationsComponent,
    MapLocationsComponent,
    PopupMarkerComponent,
    FormatAddressPipe
  ],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    LeafletModule,
    LeafletMarkerClusterModule,
    MatProgressSpinnerModule,
    MatIconModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatSortModule,
    MatPaginatorModule,
    MatTableModule,
    MatButtonModule,
    MatRippleModule,
    MatSortModule,
    MatMenuModule,
    FuseSharedModule,
    FuseSidebarModule,
    FilterLocationsModule,
    DialogLocationsModule,
    DialogLocationSectorModule,
    DialogLocationEnvironmentModule,
    ExportDialogModule,
  ],
  exports: [
    LocationComponent
  ],
  providers: [
    LocationService,
    DialogLocationService,
    CustomCompileService
  ]
})

export class LocationsModule { }
